import { render, staticRenderFns } from "./top-brand-list.vue?vue&type=template&id=d5fdabae&scoped=true&"
import script from "./top-brand-list.vue?vue&type=script&lang=js&"
export * from "./top-brand-list.vue?vue&type=script&lang=js&"
import style0 from "./top-brand-list.vue?vue&type=style&index=0&id=d5fdabae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5fdabae",
  null
  
)

export default component.exports